const TABLE_SECTION_SELECTOR = ".section--comparison-table";
const TABLE_HEAD_SELECTOR = ".section--comparison-table thead tr";

class ComparisonTable {
  constructor() {
    this.tableSection = document.querySelector(TABLE_SECTION_SELECTOR);
    this.tableHead = document.querySelector(TABLE_HEAD_SELECTOR);

    if (!this.tableSection) {
      return;
    }

    if (this.tableHead) {
      this.initStickyTableHead();
    }
  }

  initStickyTableHead() {
    let lastScrollY = window.scrollY;
    let ticking = false;
    const threshold = 5;

    const updateScrollDirection = () => {
      const currentScrollY = window.scrollY;
      const diff = currentScrollY - lastScrollY;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.tableHead.classList.add("is-scrolling-down");
          this.tableHead.classList.remove("is-scrolling-up");
        } else {
          this.tableHead.classList.add("is-scrolling-up");
          this.tableHead.classList.remove("is-scrolling-down");
        }

        lastScrollY = currentScrollY;
      }

      ticking = false;
    };

    window.addEventListener(
      "scroll",
      () => {
        if (!ticking) {
          window.requestAnimationFrame(updateScrollDirection);
          ticking = true;
        }
      },
      { passive: true },
    );
  }
}

if (document.querySelector(TABLE_SECTION_SELECTOR)) {
  new ComparisonTable();
}
